import React, { useCallback } from "react";
import ReusableTable from "./ReusableTable";
import { fetchCuttingMeetings } from "../util/fetchUserUtil";

export const CuttingMeetings = () => {
  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchCuttingMeetings(postData);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  const actionButtonsMeta = [
    {
      name: "New Meeting",
      action: "create_cuttings_meeting",
    },
  ];

  return (
    <>
      <ReusableTable
        key={"telecom_meetings"}
        tableType={"telecom_meetings"}
        tableName={"Zoom Meetings"}
        needGlobalFilter={false}
        needColumnFilter={true}
        needPagination={true}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
      />
    </>
  );
};

export default CuttingMeetings;
